import React from 'react';
import './ChordLine.css';

const ChordLine = ({ text, onChange }) => {
  const safeText = text || ""; 
  // Split by spaces to get tokens
  const tokens = safeText.split(' ');

  // 1. Handle Updating an Existing Word/Chord
  const handleWordClick = (index, currentChord) => {
    const newChord = prompt("Edit Chord:", currentChord || "");
    if (newChord === null) return; // User cancelled

    const cleanWord = tokens[index].replace(/\[.*?\]/g, '');
    
    // If word is empty (standalone chord) and user clears chord, remove the token entirely
    if (cleanWord === "" && newChord === "") {
        const newTokens = tokens.filter((_, i) => i !== index);
        onChange(newTokens.join(' '));
    } else {
        tokens[index] = newChord ? `[${newChord}]${cleanWord}` : cleanWord;
        onChange(tokens.join(' '));
    }
  };

  // 2. Handle Inserting a New Chord in a Space
  const handleInsertChord = (index) => {
    const newChord = prompt("Insert Chord between words:");
    if (!newChord) return;

    // Insert a standalone chord token (e.g. "[G]") at the specific index
    // This creates a "Word" that has a chord but empty lyrics
    const newTokens = [...tokens];
    newTokens.splice(index, 0, `[${newChord}]`); 
    onChange(newTokens.join(' '));
  };

  return (
    <div className="chord-line">
      {/* Map through words, but add spacers IN BETWEEN */}
      {tokens.map((token, index) => {
        const chordMatch = token.match(/\[(.*?)\]/);
        const chord = chordMatch ? chordMatch[1] : null;
        const lyric = token.replace(/\[.*?\]/g, '');

        return (
          <React.Fragment key={index}>
            {/* A. The Spacer BEFORE this word */}
            <div 
              className="chord-spacer" 
              onClick={() => handleInsertChord(index)}
              title="Click to insert chord here"
            >
              <div className="spacer-guide">+</div>
            </div>

            {/* B. The Word Itself */}
            <div 
              className="word-container"
              onClick={() => handleWordClick(index, chord)}
            >
              <div className="chord-text">
                {chord || "\u00A0"}
              </div>
              <div className="lyric-text">
                {/* If lyric is empty (standalone chord), show a dash or space so it's clickable */}
                {lyric || ""} 
              </div>
            </div>
          </React.Fragment>
        );
      })}

      {/* C. Final Spacer at the very end of the line */}
      <div 
        className="chord-spacer" 
        onClick={() => handleInsertChord(tokens.length)}
        title="Add chord at end"
      >
        <div className="spacer-guide">+</div>
      </div>
    </div>
  );
};

export default ChordLine;